import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import { SetField } from './SetField';
import { NamedEntity } from '../../../types/entities/NamedEntity';
import { FieldComponent } from '../../../types/FieldComponent';
import { compareText } from '../comparators/compareText';
import { SchemaWithClient } from '../../../types/SchemaWithClient';

type Props<T extends NamedEntity> = {
  active: boolean;
  onChange: (value: T) => void;
  schema: any;
  value?: any;
  hasTooltip: boolean;
  addingNewEntity?: boolean;
  accordingToValue: any;
  disabled: boolean;
  mui: boolean;
  column?: any;
  allValue?: any;
  mainSchema?: any;
  compact?: boolean;
  title?: string;
};

export const SelectField = <T extends NamedEntity>({
  active,
  onChange,
  schema,
  value,
  hasTooltip,
  accordingToValue,
  addingNewEntity,
  disabled,
  mui,
  column,
  allValue,
  mainSchema,
  compact,
  title,
}: Props<T>): ReactElement | null => {

  return (
    <>
    </>
  );
};

SelectField.tableAdapter = <T extends NamedEntity = NamedEntity>(
  schema: SchemaWithClient<T>
) => {
  const Field: FieldComponent<T, T[]> = ({
    onChange,
    isActive: active,
    value,
    hasTooltip,
    accordingToValue,
    addingNewEntity,
    mui,
    disabled,
    column,
    allValue,
    schema,
    compact,
    title,
  }) => {
    return (
      <SelectField
        active={active}
        onChange={onChange}
        schema={schema}
        value={value}
        hasTooltip={hasTooltip ? true : false}
        addingNewEntity={addingNewEntity ? true : false}
        accordingToValue={accordingToValue}
        mui={mui ? true : false}
        disabled={disabled ? true : false}
        column={column ? column : {}}
        allValue={allValue}
        mainSchema={schema}
        compact={compact}
        title={title}
      />
    );
  };

  Field.includes = (query = [], value) =>
    value
      ? query.length === 0 || query.some((item) => value.id === item.id)
      : false;
  Field.comparator = (one, other) => compareText(one?.name, other?.name);
  Field.FilterRenderer = SetField.tableAdapter(schema).FilterRenderer;

  return Field;
};
